// Mock data for Regenr8 International website

export const companyInfo = {
  name: "Regenr8 International FZ LLC",
  tagline: "GROWING BRANDS GLOBALLY",
  address: {
    line1: "Fujairah - Twin Towers",
    line2: "P.O. Box 4422, Fujairah",
    country: "United Arab Emirates"
  },
  phone: "+971 50 551 4000",
  email: "connect@regenr8intl.com",
  linkedin: "https://linkedin.com/company/regenr8-international"
};

export const homeContent = {
  hero: {
    headline: "Expanding Brands and Manufacturers Into Global Markets",
    subheadline: "Strategic guidance and market access expertise to help you grow beyond borders with confidence.",
    cta: "Partner With Us"
  },
  valueProps: [
    {
      title: "Strategic Market Entry",
      description: "Navigate complex international markets with proven strategies and local expertise."
    },
    {
      title: "Global Partnerships",
      description: "Connect with distributors, investors, and strategic partners worldwide."
    },
    {
      title: "Sustainable Growth",
      description: "Build lasting international presence through careful planning and execution."
    }
  ]
};

export const aboutContent = {
  mission: "At Regenr8 International, we empower brands and manufacturers to achieve sustainable global expansion through strategic guidance, market intelligence, and trusted partnerships.",
  vision: "To be the preferred international expansion partner for ambitious brands seeking to make their mark on the global stage.",
  values: [
    {
      title: "Global Perspective",
      description: "We bring deep understanding of international markets and cultural nuances to every partnership."
    },
    {
      title: "Strategic Excellence",
      description: "Our approach is methodical, data-driven, and focused on long-term success."
    },
    {
      title: "Trust & Integrity",
      description: "We build relationships based on transparency, reliability, and mutual growth."
    },
    {
      title: "Results-Oriented",
      description: "Your success in international markets is our ultimate measure of achievement."
    }
  ],
  team: [
    {
      name: "Rui Martins",
      role: "Co-Founder & Partner",
      location: "Dubai, UAE",
      image: "/rui-martins.jpg"
    },
    {
      name: "Marie Beyadh",
      role: "Co-Founder & Partner",
      location: "London, UK",
      image: "/marie-beyadh.jpg"
    },
    {
      name: "Jennifer Lee",
      role: "Co-Founder & Partner",
      location: "Kuala Lumpur, Malaysia",
      image: "/jennifer-lee.jpg"
    }
  ]
};

export const servicesContent = [
  {
    title: "International Market Entry Strategy",
    description: "Comprehensive market analysis, regulatory guidance, and entry planning to ensure successful launch in new territories.",
    features: [
      "Market research and opportunity assessment",
      "Regulatory compliance and legal framework navigation",
      "Entry strategy development and roadmap creation",
      "Risk assessment and mitigation planning"
    ]
  },
  {
    title: "Brand Expansion Support",
    description: "End-to-end support for established brands looking to scale their international presence and market share.",
    features: [
      "Brand positioning for international markets",
      "Marketing and communication strategy",
      "Distribution channel development",
      "Performance tracking and optimization"
    ]
  },
  {
    title: "Manufacturer Representation",
    description: "Professional representation services connecting manufacturers with international buyers, distributors, and partners.",
    features: [
      "Global network of qualified buyers and distributors",
      "Trade show and exhibition representation",
      "Negotiation and contract support",
      "Ongoing relationship management"
    ]
  },
  {
    title: "Business Development & Market Access",
    description: "Strategic business development services to unlock new markets and create sustainable revenue streams.",
    features: [
      "Partnership identification and vetting",
      "Market entry facilitation",
      "Sales channel development",
      "Strategic alliance formation"
    ]
  }
];

export const whyRegenr8Content = {
  headline: "Why Choose Regenr8 International",
  reasons: [
    {
      title: "Proven International Expertise",
      description: "Our team brings decades of combined experience in international business development, market entry, and cross-border partnerships. We understand the complexities of global expansion and have successfully guided numerous brands through their international growth journey."
    },
    {
      title: "Strategic Network & Partnerships",
      description: "Leverage our extensive network of distributors, investors, and business partners across key global markets. We provide access to opportunities that would take years to develop independently, accelerating your path to international success."
    },
    {
      title: "Tailored Growth Solutions",
      description: "We recognize that every brand and manufacturer has unique goals and challenges. Our approach is fully customized to your specific needs, market conditions, and growth objectives, ensuring strategies that truly work for your business."
    },
    {
      title: "Results-Driven Approach",
      description: "Success is measured by tangible results. We focus on delivering measurable outcomes - from market entry to revenue growth - with clear KPIs and continuous performance optimization throughout our partnership."
    }
  ]
};
